module.exports = __webpack_public_path__ + "assets/img/djxhsj.238e85cf.jpg";